export default __webpack_public_path__ + "static/media/leave.e0c4da0e.png";